import React from 'react';
import { Phone, Instagram, MapPin } from 'lucide-react';

const Footer = ({ onOpenForm }) => {
  const currentYear = new Date().getFullYear();

  const handleInstagramClick = () => {
    window.open('https://instagram.com/arturismobsb', '_blank');
  };

  return (
    <footer className="bg-gray-900 text-white pt-16 pb-8">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_turismo-landing-ar/artifacts/137t1god_LOGO%20AR%20BRANCA%20SOMBRA.png" 
              alt="A.R. Turismo - 10 Anos" 
              className="h-20 w-auto mb-4"
            />
            <p className="text-gray-400 leading-relaxed mb-4">
              Há mais de 10 anos realizando sonhos de viagem com qualidade, 
              segurança e dedicação. Sua viagem perfeita começa aqui!
            </p>
            <div className="flex items-start gap-2 text-gray-400">
              <MapPin className="w-5 h-5 text-red-500 flex-shrink-0 mt-1" />
              <span>Brasília - DF</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xl font-bold mb-4">Nossos Destinos</h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={onOpenForm}
                  className="text-gray-400 hover:text-red-500 transition-colors duration-300"
                >
                  Porto Seguro - BA
                </button>
              </li>
              <li>
                <button
                  onClick={onOpenForm}
                  className="text-gray-400 hover:text-red-500 transition-colors duration-300"
                >
                  Rio de Janeiro - RJ
                </button>
              </li>
              <li>
                <button
                  onClick={onOpenForm}
                  className="text-gray-400 hover:text-red-500 transition-colors duration-300"
                >
                  Porto de Galinhas - PE
                </button>
              </li>
              <li>
                <button
                  onClick={onOpenForm}
                  className="text-gray-400 hover:text-red-500 transition-colors duration-300"
                >
                  João Pessoa - PB
                </button>
              </li>
              <li>
                <button
                  onClick={onOpenForm}
                  className="text-gray-400 hover:text-red-500 transition-colors duration-300"
                >
                  Outros Destinos
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-xl font-bold mb-4">Entre em Contato</h4>
            <div className="space-y-4">
              <button
                onClick={onOpenForm}
                className="flex items-center gap-3 text-gray-400 hover:text-green-500 transition-colors duration-300 w-full text-left group"
              >
                <div className="w-10 h-10 bg-green-600 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                  <Phone className="w-5 h-5 text-white" />
                </div>
                <div>
                  <p className="text-sm text-gray-500">Solicite um Orçamento</p>
                  <p className="font-semibold">(61) 98635-7158</p>
                </div>
              </button>

              <button
                onClick={handleInstagramClick}
                className="flex items-center gap-3 text-gray-400 hover:text-pink-500 transition-colors duration-300 w-full text-left group"
              >
                <div className="w-10 h-10 bg-gradient-to-br from-purple-600 to-pink-600 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                  <Instagram className="w-5 h-5 text-white" />
                </div>
                <div>
                  <p className="text-sm text-gray-500">Instagram</p>
                  <p className="font-semibold">@arturismobsb</p>
                </div>
              </button>
            </div>

            {/* Social Media Buttons */}
            <div className="mt-6">
              <p className="text-sm text-gray-500 mb-3">Siga-nos nas redes sociais:</p>
              <div className="flex gap-3">
                <button
                  onClick={onOpenForm}
                  className="w-12 h-12 bg-green-600 hover:bg-green-700 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
                  aria-label="Solicitar Orçamento"
                >
                  <Phone className="w-6 h-6 text-white" />
                </button>
                <button
                  onClick={handleInstagramClick}
                  className="w-12 h-12 bg-gradient-to-br from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
                  aria-label="Instagram"
                >
                  <Instagram className="w-6 h-6 text-white" />
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm text-center md:text-left">
              © {currentYear} A.R. Turismo. Todos os direitos reservados.
            </p>
            <p className="text-gray-500 text-sm text-center md:text-right">
              Desenvolvido com ❤️ para proporcionar as melhores viagens
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
